var utils = require( './utils' );

var header_login = (function( $ ) {

	var $anchor;

	var $form_bar;

	var _init = function() {
		$anchor   = $( '#header-sign-in' );
		$form_bar = $( '#login-bar' );

		if ( $anchor.length > 0 && $form_bar.length > 0 ) {
			$anchor.on( 'click', _show_form );
			$form_bar.find( '.close' ).on( 'click', _hide_form );
		}
	};

	var _show_form = function( e ) {
		if ( utils.viewport_size().width < 992 ) {
			return;
		}

		e.preventDefault();

		$form_bar.addClass( 'open' );
	};

	var _hide_form = function( e ) {
		e.preventDefault();

		$form_bar.removeClass( 'open' );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = header_login;